<template>
  <div class="bg-red tcenter pt5">
    <router-link to="/">
      <img src="../../assets/images/index_01_03.png" class="vtop">
    </router-link>　        　　                    　　        　
  </div>
</template>

<script>
    export default {
        name: "Top"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/search/Top.vue